import React from 'react'

import { Form, Col, Button } from '_zari/core'

import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'
import ListaMonedasConstant from 'constants/listaDeMonedas'

import { NuevoClienteModal, HistorialVentasModal } from 'sharedComponents/modals'
import { Select2Cliente } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { IdGen } from 'utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const [mostrarEditarModal, setMostrarEditarModal] = React.useState(false)
  const [mostrarHistorialModal, setMostrarHistorialModal] = React.useState(false)
  const [flagBuscarPorAlias, setFlagBuscarPorAlias] = React.useState(false)
  const [__keyReadOnly, setKeyReadOnly] = React.useState(IdGen.newId())

  const editarDataRef = React.useRef()

  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.tipoDocumentoSocio = data.tipoDocumento
      values.nombreSocio = data.razonSocial

      if (data.tipoDocumento === TiposDeDocumentoIdentificacionConstant.RUC) {
        values.tipoDocumento = TiposDeDocumentoSunatConstant.FACTURA
      }

      setValues(values)
    })
  }

  const onCreate = (socioCreado, closeModal) => {
    values._idSocio = socioCreado._id
    values.nombreSocio = socioCreado.razonSocial
    values.codigoSocio = socioCreado.codigo
    values.documentoSocio = socioCreado.numeroDocumento
    values.tipoDocumentoSocio = socioCreado.tipoDocumento

    if (socioCreado.tipoDocumento === TiposDeDocumentoIdentificacionConstant.RUC) {
      values.tipoDocumento = TiposDeDocumentoSunatConstant.FACTURA
    }

    setValues(values)
    closeModal()
  }

  const clickClear = () => {
    values._idSocio = ''
    values.nombreSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.tipoDocumentoSocio = ''
    values.moneda = ListaMonedasConstant.SOLES
    values._idAnticipo = ''
    values.montoAnticipo = 0

    values.tipoDocumento = TiposDeDocumentoSunatConstant.BOLETA

    setValues(values)
  }

  const onUpdate = () => {
    clickClear()

    setMostrarEditarModal(false)
    setKeyReadOnly(IdGen.newId())
    editarDataRef.current = {}
  }

  const clickEditar = React.useCallback(() => {
    SocioCrud.obtenerxIdAsEdicionFromVentas(values._idSocio).then(({ data }) => {
      editarDataRef.current = data
      setMostrarEditarModal(true)
    })
  }, [values._idSocio])

  return (
    <>
      <Form.Group>
        <Form.Label text='CLIENTE' htmlFor='input-codigoRucSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          {values._idSocio ? (
            <ClearInputGroup
              key={__keyReadOnly}
              id='input-codigoRucSocio'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
              append={
                <>
                  <Button outline color='warning' onClick={clickEditar}>
                    S
                  </Button>
                  <Button outline onClick={() => setMostrarHistorialModal(true)}>
                    H
                  </Button>
                </>
              }
            />
          ) : (
            <>
              <Select2Cliente
                disabled={fIsSubmitting}
                id='codigoRucSelect'
                onChange={onChangeSocioHandler}
                showNewButton
                onCreate={onCreate}
                flagBuscarPorAlias={flagBuscarPorAlias}
              />
              <Form.Checkbox
                checked={flagBuscarPorAlias}
                disabled={fIsSubmitting}
                id='checkbox-buscarPorAlias'
                label='Buscar por alias'
                onClick={() => setFlagBuscarPorAlias(prev => !prev)}
              />
            </>
          )}
          {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
        </Col>
      </Form.Group>
      {mostrarEditarModal && (
        <NuevoClienteModal
          show={mostrarEditarModal}
          handleClose={() => setMostrarEditarModal(false)}
          edicionData={editarDataRef.current}
          onUpdate={onUpdate}
        />
      )}
      {mostrarHistorialModal && (
        <HistorialVentasModal
          handleClose={() => setMostrarHistorialModal(false)}
          show={mostrarHistorialModal}
          idSocio={values._idSocio}
        />
      )}
    </>
  )
}

export default React.memo(SocioFormGroup)
